import React, { Component } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { baseURL } from './MyApi';
import { t } from 'i18next';



class RMstats extends Component {

  constructor(props) {
    super(props);
    // N’appelez pas `this.setState()` ici !
    this.state = {
      isBtnActive1: true,
      isBtnActive2: false,
      isBtnActive3: false,
      data: [],
      lineTitle: t('LRMPA'),
      lineTitleYaxis: t('montant'),
      format: '{point.y:,.0f}',
      pointFormat: '{series.name}: {point.y}'
    };
    this.getLineChart1 = this.getLineChart1.bind(this);
    this.getLineChart2 = this.getLineChart2.bind(this);
    this.getLineChart3 = this.getLineChart3.bind(this);


  }



  componentDidMount() {
    this.DefaultLineChart();
  }



  DefaultLineChart = async () => {
    try {
      this.setState({ isBtnActive1: true,isBtnActive2: false,isBtnActive3: false});
      const response = await fetch(baseURL + this.props.tenant + '/getRecetteMensAllYear');
      const jsonData = await response.json();
      this.setState({ data: jsonData });
      this.setState({ lineTitle: t('LRMPA') });
      this.setState({ lineTitleYaxis: t('montant') });
      this.setState({ format: '{point.y:,.0f}' });
      this.setState({ pointFormat: '{series.name}: {point.y}' });
    } catch (err) {
      console.error(err.message);
    }
  }






  getLineChart1 = async () => {
    try {
      this.setState({ isBtnActive1: true,isBtnActive2: false,isBtnActive3: false});
      const response = await fetch(baseURL + this.props.tenant + '/getRecetteMensAllYear');
      const jsonData = await response.json();
      this.setState({ data: jsonData });
      this.setState({ lineTitle: t('LRMPA') });
      this.setState({ lineTitleYaxis: t('montant') });
      this.setState({ format: '{point.y:,.0f}' });
      this.setState({ pointFormat: '{series.name}: {point.y}' });
    } catch (err) {
      console.error(err.message);
    }
  }

  getLineChart2 = async () => {
    try {
      this.setState({ isBtnActive1: false,isBtnActive2: true,isBtnActive3: false});
      const response = await fetch(baseURL + this.props.tenant + '/getCumulRecetteMensAllYear');
      const jsonData = await response.json();
      this.setState({ data: jsonData });
      this.setState({ lineTitle: t('CDRMPA') });
      this.setState({ lineTitleYaxis: t('montant') });
      this.setState({ format: '{point.y:,.0f}' });
      this.setState({ pointFormat: '{series.name}: {point.y}' });
    } catch (err) {
      console.error(err.message);
    }
  }

  getLineChart3 = async () => {
    try {
      this.setState({ isBtnActive1: false,isBtnActive2: false,isBtnActive3: true});
      const response = await fetch(baseURL + this.props.tenant + '/getEvolutionT1RecetteMensAllYear');
      const jsonData = await response.json();
      this.setState({ data: jsonData });
      this.setState({ lineTitle: t('EDTDRT1') });
      this.setState({ lineTitleYaxis: t('taux') });
      this.setState({ format: '{point.y:,.2f} %' });
      this.setState({ pointFormat: '{series.name}: {point.y:,.2f} %' });
    } catch (err) {
      console.error(err.message);
    }
  }

  render() {

    Highcharts.setOptions({
      lang: {
        viewData: t('viewhideData'),
        hideData: t('viewhideData'),
        viewFullscreen: t('viewFullscreen'),
        exitFullscreen: t('exitFullscreen'),
        exportData: {
          categoryHeader: t('mois_annee')
        } ,
        }
    });


    let option = {
      exporting:{
        buttons:{
          contextButton:{
            menuItems:['viewFullscreen','printChart','viewData','separator','downloadPNG','downloadJPEG','downloadPDF','downloadSVG','separator','downloadXLS','downloadCSV']
          }
        },
        menuItemDefinitions: {
          
          "printChart": {text: t('printChart')},
          "downloadPNG": {text: t('downloadPNG')},
          "downloadJPEG": {text: t('downloadJPEG')},
          "downloadPDF": {text: t('downloadPDF')},
          "downloadSVG": {text: t('downloadSVG')},
          "downloadXLS": {text: t('downloadXLS')},
          "downloadCSV": {text: t('downloadCSV')}
          }
      },
      accessibility: {
        enabled: false
      },
      chart: {
        type: this.props.typeChart
      },
      title: {
        text: this.state.lineTitle,
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        }
      },

      xAxis: {
        categories: [t('janvier'), t('fevrier'), t('mars'), t('avril'), t('mai'), t('juin'), t('juillet'), t('aout'), t('septembre'), t('octobre'), t('novembre'), t('decembre'), t('complementaire')],
        reversed: this.props.currentLanguageCode === 'ar' ? true : false
      },
      yAxis: {
        title: {
          text: this.state.lineTitleYaxis,
          style: {
            fontSize: '18px',
            fontWeight: 'bold'
          }
        },

        labels: {
          format: '{value}',
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0);
          }
        },
        opposite: this.props.currentLanguageCode === 'ar' ? true : false
      },

      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: this.state.format,
          },
          enableMouseTracking: true
        }
      },
      tooltip: {
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        },
        pointFormat: this.state.pointFormat
      },
      series: this.state.data
    }


    return (




      <div className="col-md-12 ">



<div className='padMarg15'>
        <button className={this.state.isBtnActive1 ? 'col-md-4 example_g activeBtnAnimation' : 'col-md-4 example_g'} onClick={this.getLineChart1}>
          {t('LRMPA')}
        </button>
        <button className={this.state.isBtnActive2 ? 'col-md-4 example_g activeBtnAnimation' : 'col-md-4 example_g'} onClick={this.getLineChart2}>
          {t('CDRMPA')}
        </button>
        <button className={this.state.isBtnActive3 ? 'col-md-4 example_g activeBtnAnimation' : 'col-md-4 example_g'} onClick={this.getLineChart3}>
          {t('EDTDRT1')}
        </button>
</div>

        <HighchartsReact highcharts={Highcharts} options={option} />




      </div>


    );
  }
}
export default RMstats;
